import React from 'react';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  const CART_URL = 'https://pagos.avanzalab.online/cart/52985716146490:1';
  return <section className="py-20 px-4 bg-black text-white text-center" data-id="element-79">
      <div className="max-w-4xl mx-auto" data-id="element-80">
        <h2 className="text-3xl md:text-5xl font-black mb-8 text-white" data-id="element-81">
          El mercado ya está creciendo en Argentina.
        </h2>

        <div className="space-y-4 text-xl md:text-2xl font-light mb-12 text-gray-300" data-id="element-82">
          <p data-id="element-83">Los clientes están.</p>
          <p data-id="element-84">La demanda existe.</p>
          <p className="font-bold text-white" data-id="element-85">
            La pregunta es si vas a prepararte para aprovecharla.
          </p>
        </div>

        <div className="space-y-2 mb-12 text-lg md:text-xl font-medium text-amber-500" data-id="element-86">
          <p data-id="element-87">👉 Aprovechá el precio de lanzamiento</p>
          <p data-id="element-88">👉 Accedé hoy</p>
          <p data-id="element-89">👉 Empezá mañana</p>
        </div>

        <div className="mb-12" data-id="element-90">
          <p className="text-4xl md:text-6xl font-black text-white uppercase tracking-tight" data-id="element-91">
            De 0. <br data-id="element-92" />
            <span className="text-amber-500" data-id="element-93">A tu primer trabajo cobrado.</span>
          </p>
        </div>

        <a href={CART_URL} className="inline-flex items-center justify-center gap-3 bg-amber-500 hover:bg-amber-400 text-black text-2xl md:text-3xl font-black py-6 px-12 rounded-full shadow-lg shadow-amber-500/20 hover:shadow-xl hover:shadow-amber-400/30 hover:scale-105 transition-all" data-id="element-94">
          QUIERO ACCEDER AHORA
          <ArrowRight className="w-8 h-8" data-id="element-95" />
        </a>
      </div>
    </section>;
}